<div [ngStyle]="{'font-family':planDetails?.fontStyle}">
  <div class="doNotPrint">
    <div class="row">
      <div class="col col-xs-9 col-sm-9 col-md-9 col-lg-9">
      </div>
      <div class="col col-xs-3  col-sm-3 col-md-3 col-lg-3" *ngIf="planDetails?.logoUploaded === 'Y'">
        <img alt="Logo Image" class="img img-responsive img-fluid align-img" [src]="imageData">
      </div>
    </div>
    <ng-http-loader [backgroundColor]="ssncLoaderColor"></ng-http-loader>
    <div class="progress" *ngIf="showView" style="margin-bottom: 1%;margin-top:1%;">
      <div class="progress-bar" [ngStyle]="{'background-color':planDetails?.urlColorSelection}" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>

    <div class="row">
      <div class="col col-xs-9 col-sm-9 col-md-9 col-lg-9 mycontent-left url-desc-scroll-bar"
        [ngStyle]="{'border-right': '1px solid'+planDetails?.urlColorSelection}">
        <div #urlBodyText></div>
      </div>
      <div class="col col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="row">
          <div class="col-xs-0  col-sm-0 col-md-0 col-lg-0">
          </div>
          <div class="col col-xs-12  col-sm-12 col-md-12 col-lg-12">
            <p class="h8" *ngIf="showView"><b>Helpful Plan Documents</b></p>
          </div>
        </div>
        <div class="overflow-auto align-documents">
        <ul class="list-group">
          <li class="list-group-item li-custom-border" 
            (click)="fetchPDFReport(planDetails.planId,'ComprehensiveFormulary')" *ngIf="pdfDetailsList.includes(0)">
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label=" pdf icon">picture_as_pdf</mat-icon>
            <!-- <i  class="fa fa-file-pdf-o fa-pdf-color"></i>  -->
            Formulary List of Covered Drugs</li>
          <li class="list-group-item li-custom-border" *ngIf="pdfDetailsList.includes(-1)"
              (click)="fetchPDFReport(planDetails.planId,'FORMULARYUPDATES')">
              <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
              Formulary Updates</li>
          <li class="list-group-item li-custom-border" *ngIf="pdfDetailsList.includes(5)"
            (click)="fetchPDFReport(planDetails.planId,'AbridgedFormularyCommercial')">
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
              Abridged Formulary List of Covered Drugs</li>
          <li class="list-group-item li-custom-border" *ngIf="pdfDetailsList.includes(25)"
            (click)="fetchPDFReport(planDetails.planId,'QuantityLimit')"> 
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
            Medications with Quantity Limits</li>
          <li class="list-group-item li-custom-border" *ngIf="pdfDetailsList.includes(24)"
            (click)="fetchPDFReport(planDetails.planId,'PriorAuthorization')">
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
            Medications with Prior Authorizations</li>
          <li class="list-group-item li-custom-border" *ngIf="pdfDetailsList.includes(28)"
            (click)="fetchPDFReport(planDetails.planId,'StepTherapy')">
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
            Medications with Step Therapy</li>
        </ul>
        <ul *ngFor="let otherPDFDetails of otherPDFDetailsList" class="list-group">
          <li class="list-group-item li-custom-border"
            (click)="fetchPDFReport(planDetails.planId,otherPDFDetails.additionalPDFClassificationName)">
            <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
            Medications with
            {{otherPDFDetails.additionalPDFClassificationFullName}} Designations </li>
        </ul>
        <ul *ngFor="let externalPDF of externalPDFList" class="list-group">
            <li class="list-group-item li-custom-border" (click)="fetchExternalPDFReport(planDetails.planId,externalPDF)">
              <mat-icon class="fa-pdf-color pdfIconStyle" aria-hidden="false" aria-label="pdf icon">picture_as_pdf</mat-icon>
            {{externalPDF}}</li>
        </ul>
      </div>
      </div>
    </div>

    <div class="progress" *ngIf="showView" style="margin-bottom: 1%;margin-top:1%;">
      <div class="progress-bar" [ngStyle]="{'background-color':planDetails?.urlColorSelection}" role="progressbar"
        style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>

  <app-drug-search *ngIf="showView" (errorEvent)="recieveErrorEvent($event)"></app-drug-search>
  <br>
  <br>
  <div class="row">
    <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
      <p class="default-font align-desclaimer">{{planDetails?.urlDisclaimerText}}</p>
    </div>
  </div>
  <br>
  <div style="float: right;">
    <span class="default-font"><b>{{planDetails?.planName}}</b></span>
  </div>
</div>
